<template>
<div>
    <div class="text-center px-8">
        <p class="rainbow text-3xl font-extrabold">only $59</p>
    </div>

    <form class="cultivate-form" @submit.prevent="onSubmit" @keydown="errors.clear($event.target.name)">

        <div class="bg-gray-50 px-8 py-2 mt-6 pt-6 rounded-2xl">
            <inputform label="Name" field="name" type='text' :required="true" :autofocus="true"></inputform>
            <inputform label="Email" field="email" type='email' :required="true"></inputform>
            <inputform label="Password" field="password" type='password' :required="true"></inputform>
            <inputform label="Confirm Password" field="password_confirmation" type='password' :required="true"></inputform>
            <inputform label="Promo Code" field="promocode" type='text'></inputform>
        </div>

        <div class="md:flex md:items-center pt-6">
            <div class="text-center mx-auto px-4">
                <button class="rainbowButton text-2xl" type="submit" :disabled="errors.any()">{{submit}}</button>
            </div>
        </div>

    </form>
</div>
</template>

<script>
    import store from './RegisterForm/store.js'
    import inputform from './RegisterForm/inputForm'
    import addonsform from './RegisterForm/addonsform'
    export default {
        props: ['oldname','oldemail', 'price'],

        data() { return store },

        components: { inputform, addonsform },

        created() {
            this.name = this.oldname
            this.email = this.oldemail
            this.original_cost = this.price
            this.cost = this.price
        },

        methods: {
            onSubmit () {
                this.submit = 'Loading...',
                window.axios.post('/register', {
                    'name': this.name,
                    'email': this.email,
                    'password': this.password,
                    'password_confirmation': this.password_confirmation,
                    'promocode': this.promocode,
                    'addon': this.addon
                })
                .then(response => window.location = '/purchase')
                .catch(errors => {
                    this.errors.record(errors.response.data)
                    this.submit = 'Sign Up'
                })
            }
        }
    }
</script>
